export const STAGES = [
  "preloan_eligibility",
  "created",
  "locked",
  "salary_check",
  "verified",
  "parking_stage",
  "hard_rejected",
  "commodity_purchased_requested",
  "commodity_purchased",
  "app_custcared",
  "call_initialized_unique",
  "call_approved",
  "contract_signed",
  "sanad_created",
  "nafaes_sales_ordered",
  "disbursed",
  "withdrawal_requested",
  "withdrawal_success",
] as const;

export type StageKey = (typeof STAGES)[number];

export const formatStageLabel = (stage: string): string => {
  if (stage === "call_initialized_unique") {
    return "Call Init";
  }

  if (stage === "commodity_purchased_requested") {
    return "Commodity Purchase Request";
  }

  if (stage === "commodity_purchased") {
    return "Commodity Purchased";
  }

  if (stage === "withdrawal_requested") {
    return "Withdraw Request";
  }

  if (stage === "withdrawal_success") {
    return "Withdraw Success";
  }

  if (stage === "nafaes_sales_ordered") {
    return "Nafaes Sales";
  }

  return stage
    .split("_")
    .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
    .join(" ");
};

// Number of colour steps in the hourly heatmap tables.
const HEAT_LEVELS = 5;

// Heatmap cell class: zero is muted grey, otherwise a step relative to the busiest value
// the table is scaled against. The table's theme class decides the colour family.
export const getHeatClass = (value: number, maxValue: number): string => {
  if (value <= 0) {
    return "funnel-minimal-hourly-grid-zero";
  }
  const level = Math.min(
    HEAT_LEVELS,
    Math.ceil((value / (maxValue > 0 ? maxValue : value)) * HEAT_LEVELS),
  );
  return `funnel-minimal-hourly-grid-l${level}`;
};
